import { render, staticRenderFns } from "./SupplierDetail.vue?vue&type=template&id=7cc70510"
import script from "./SupplierDetail.vue?vue&type=script&lang=js"
export * from "./SupplierDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports